import { Modal } from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

import type { InconsistencyModalItemBase } from 'src/core/modules/verification-of-payee/models';

import { InconsistencyModalItem } from './InconsistencyModalItem';

export type Labels = {
  titleLabel: string;
  descriptionLabel: string;
};

type Props<T extends InconsistencyModalItemBase> = {
  buttons: ReactNode[];
  isOpen: boolean;
  items: T[];
  labels: Labels;
  renderItemSummary: (item: T) => ReactNode;
  onClose: () => void;
};

export const InconsistencyModal = <T extends InconsistencyModalItemBase>({
  buttons,
  isOpen,
  items,
  labels,
  renderItemSummary,
  onClose,
}: Props<T>) => {
  return (
    <Modal
      actions={buttons}
      iconName="triangle-warning"
      iconVariant="warning"
      title={labels.titleLabel}
      subtitle={labels.descriptionLabel}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="mt-24 flex max-h-[190px] flex-col gap-8 overflow-y-auto">
        {items.map((item) => (
          <InconsistencyModalItem
            key={item.id}
            itemSummary={renderItemSummary(item)}
            matchingResult={item.matchingResult}
          />
        ))}
      </div>
    </Modal>
  );
};
